import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { Logo } from "./model/logo";
import { NavItem } from "./model/nav_item";
import NavBarItem from "./navbar_item";
import MenuIcon from '@mui/icons-material/Menu';

type NavBarProps = {
  logo: Logo;
  navitems: NavItem[];
};

export default function NavBar({ logo, navitems }: NavBarProps) {
  const [open, setOpen] = useState(false);
  return (
    <nav className="bg-white shadow-sm py-2">
      <div className="max-w-7xl mx-auto px-4 py-2 relative">
        {/* Mobile header: logo centralizado e botão de menu à direita */}
        <div className="grid grid-cols-3 items-center md:hidden">
          <div></div>
          <div className="justify-self-center">
            <Link to="/" className="flex items-center justify-center">
              <img src={logo.src} alt={logo.alt} className="h-20 w-auto" />
            </Link>
          </div>
          <div className="justify-self-end">
            <button
              type="button"
              aria-label="Abrir menu"
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
              className="inline-flex items-center justify-center p-2 rounded-md text-[#3A3168] hover:bg-[#f4f4f8] focus:outline-none focus:ring-2 focus:ring-[#3A3168]"
            >
              
              <MenuIcon />
            </button>
          </div>
        </div>

        {/* Mobile menu (dropdown) */}
        {open && (
          <ul className="md:hidden absolute right-4 top-16 z-50 bg-white border border-slate-200 shadow-lg rounded-md p-2 text-right flex flex-col gap-2 divide-y divide-slate-100 list-none min-w-[200px]" onClick={() => setOpen(false)}>
            {navitems.map((item, idx) => (
              <NavBarItem key={`${item.text}-${idx}`} navItem={item} />
            ))}
          </ul>
        )}

        {/* Desktop menu */}
        <div className="hidden md:flex flex-row items-center justify-between">
          <div className="md:max-w-[20%] items-center">
            <Link to="/" className="flex items-center">
              <img src={logo.src} alt={logo.alt} className="h-10 md:h-20 w-auto" />
            </Link>
          </div>
          <ul className="flex flex-row md:max-w-[80%] items-center gap-6 list-none">
            {navitems.map((item, idx) => (
              <NavBarItem key={`${item.text}-${idx}`} navItem={item} />
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}
